import {ItineraryRepository} from "../../../repositories/ItineraryRepository.ts";

export class GetItinerariesUseCase {
    constructor(private readonly tripCatalogRepository: ItineraryRepository) {

    }
    async execute() {
        return this.tripCatalogRepository.getItineraries();
    }
}
